<template>
  <div class="authWrapper new-login-wrapper">
    <div class="container">
      <div class="row whiteBG-wrap login-white-wrap">
        <div class="col-lg-7 col-md-7 no-padding">
          <div class="login-left-wrap login-otp-left-wrap">
            <div class="back-icon text-start">
              <router-link to="/password-login" class="ms-0 ps-0">Back</router-link>
            </div>
            <div class="left-login">
              <div class="rep-icon-login">
                <img src="../../assets/images/dashboard-rep.svg" alt="image-fluid" />
              </div>
              <div class="">
                <router-link to="/smart-login">
                  <button class="qr-login-btn">
                    <img src="../../assets/images/qr-icon.svg" alt="qr icon" class="me-2" />Login with QR
                  </button>
                </router-link>
              </div>
            </div>
            <h4 class="login-title mb-1">Login to Continue</h4>
            <div class="auth-form pt-3 pb-3">
              <div class="email-change-wrap">
                <div class="">{{ email }}</div>
                <div class="login-highlight" @click="routeToLogin">Change</div>
              </div>
              <form class="">
                <div class="mt-3">
                  <div class="d-flex justify-content-between">
                    <div class="">
                      <label class="opt-label mt-0">Enter OTP<span class="required-label">*</span></label>
                    </div>
                  </div>
                  <div class="otp-input-wrapper d-flex">
                    <input
                      v-for="(_, idx) in 6"
                      :key="idx"
                      ref="inputs"
                      v-model="digits[idx]"
                      type="tel"
                      maxlength="1"
                      autocomplete="one-time-code"
                      class="otp-input"
                      :class="{ 'error-border': otpErrorFlag }"
                      :disabled="isLockedOut"
                      @input="handleInput(idx, $event)"
                      @keydown.delete="handleDelete(idx, $event)"
                      @paste.prevent="handlePaste"
                      @focus="clearError"
                      :aria-label="`OTP digit ${idx + 1}`"
                    >
                  </div>
                  <div class="valid-error mt-2" v-if="otpErrorFlag && !isLockedOut">
                    {{ errorMsg }}
                  </div>
                </div>
              </form>
              <button
                @click="verifyToken"
                class="submit-btn mt-3 next-btn"
                :disabled="formLoader || !isOtpComplete || isLockedOut"
                type="button"
              >
                <b-spinner v-if="formLoader" small />
                Login
              </button>
              <login-otp
                v-if="!isLockedOut"
                @sendOTP="sendOTP"
                :expirySecond="60"
                :setSpinnerLoader="otpLoader"
              />
              <!-- Lockout Timer -->
              <lockout-timer
                v-if="isLockedOut"
                :lockout-seconds="lockoutSeconds"
                @lockout-expired="handleLockoutExpired"
              />
            </div>
          </div>
        </div>
        <div class="col-lg-5 col-md-5 no-padding">
          <login-in-carsoule />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import NewLoginOTP from "../../components/ui/NewLoginOTP";
import LockoutTimer from "../../components/ui/OtpLockoutTimer.vue";
import helper from "@/resource/Helper";
import axios from "axios";
import store from "@/store";
import Logincarsoule from "./Logincarsoule";

export default {
  name: "LoginOtp",
  components: {
    'login-in-carsoule': Logincarsoule,
    'login-otp': NewLoginOTP,
    'lockout-timer': LockoutTimer
  },
  data() {
    return {
      digits: Array(6).fill(''),
      otpLoader: false,
      formLoader: false,
      otpErrorFlag: false,
      errorMsg: '',
      setSpinnerLoader: false,
      isLockedOut: false,
      lockoutSeconds: 0
    };
  },
  computed: {
    ...mapGetters({
      deviceId: "deviceId",
      email: "repEmail",
    }),
    isOtpComplete() {
      return this.digits.every(d => d.length === 1 && /\d/.test(d));
    },
    otp() {
      return this.digits.join('');
    }
  },
  mounted() {
    this.focusFirstInput();
  },
  methods: {
    routeToLogin() {
      this.$router.push('/login');
    },
    handleInput(index, event) {
      if (this.isLockedOut) return;
      const value = event.target.value.replace(/\D/g, '');
      this.digits.splice(index, 1, value.slice(-1));

      if (value && index < 5) {
        this.$refs.inputs[index + 1].focus();
      }

      if (this.isOtpComplete) {
        this.verifyToken();
      }
    },
    handleDelete(index) {
      if (this.isLockedOut) return;
      if (index > 0 && !this.digits[index]) {
        this.$refs.inputs[index - 1].focus();
      }
    },
    handlePaste(event) {
      if (this.isLockedOut) return;
      const pasteData = (event.clipboardData || window.clipboardData)
        .getData('text/plain')
        .replace(/\D/g, '')
        .slice(0, 6)
        .split('');

      this.digits = [...pasteData, ...Array(6 - pasteData.length).fill('')];
      this.focusInput(pasteData.length);

      if (this.isOtpComplete) {
        this.verifyToken();
      }
    },
    focusFirstInput(retry = 5) {
      this.$nextTick(() => {
        const input = this.$refs.inputs?.[0];
        if (input && !this.isLockedOut) {
          input.focus();
        } else if (retry > 0) {
          setTimeout(() => this.focusFirstInput(retry - 1), 50);
        }
      });
    },
    focusInput(index) {
      if (this.isLockedOut) return;
      this.$nextTick(() => {
        const targetIndex = Math.min(index, 5);
        this.$refs.inputs[targetIndex]?.focus();
      });
    },
    clearError() {
      if (this.isLockedOut) return;
      this.otpErrorFlag = false;
      this.errorMsg = '';
    },
    parseLockoutDuration(message) {
      const match = message.match(/(\d+)\s*minute[s]?(\s*and\s*(\d+)\s*second[s]?)?|(\d+)\s*second[s]?/);
      if (!match) {
        console.warn('Failed to parse lockout duration:', message);
        return 0;
      }
      const minutes = parseInt(match[1]) || 0;
      const seconds = parseInt(match[3]) || parseInt(match[4]) || 0;
      return minutes * 60 + seconds;
    },
    verifyToken() {
      if (!this.isOtpComplete) {
        this.otpErrorFlag = true;
        this.errorMsg = "Please enter a 6-digit OTP to proceed";
        return;
      }

      this.formLoader = true;
      this.clearError();

      axios
        .post(this.$endpoint.API_V4_VALIDATE_LOGIN_OTP, {
          email: this.email,
          device_id: this.deviceId,
          verification_code: this.otp,
        })
        .then((response) => {
          if (response.data.status === "success") {
            store.commit("setAuthentication", true);
            helper.setLoginDetails(response.data);
          }
        })
        .catch((error) => {
          const errorResponse = error.response?.data;
          console.log('Verify OTP error:', errorResponse);
          if (errorResponse?.statusCode === 429 || error.response?.status === 429) {
            this.isLockedOut = true;
            this.lockoutSeconds = this.parseLockoutDuration(errorResponse?.message || '');
            this.otpErrorFlag = false; // Clear error message
            this.errorMsg = ''; // Ensure no error message is shown
          } else {
            this.otpErrorFlag = true;
            this.errorMsg = errorResponse?.message || "The OTP you entered is incorrect. Please check your input or request a new OTP.";
          }
          this.setSpinnerLoader = false;
        })
        .finally(() => {
          this.formLoader = false;
          this.setSpinnerLoader = false;
        });
    },
    sendOTP() {
      if (this.isLockedOut) return;
      this.otpLoader = true;
      this.$store.commit("setAuthentication", false);
      axios
        .post(this.$endpoint.API_V4_GENERATE_OTP, {
          email: this.email,
          device_id: this.deviceId,
          type: `email`
        })
        .then((response) => {
          if (response.data.status === "success") {
            this.otpLoader = false;
            helper.infoMessage(this, response.data.status, response.data.message);
            this.digits = Array(6).fill('');
            this.focusFirstInput();
          }
        })
        .catch((error) => {
          const errorResponse = error.response?.data;
          console.log('Generate OTP error:', errorResponse);
          if (errorResponse?.status === "error") {
            this.otpLoader = false;
            if (errorResponse.statusCode === 429 || error.response?.status === 429) {
              this.isLockedOut = true;
              this.lockoutSeconds = this.parseLockoutDuration(errorResponse.message);
              this.otpErrorFlag = false; // Clear error message
              this.errorMsg = ''; // Ensure no error message is shown
            } else {
              this.otpErrorFlag = true;
              this.errorMsg = errorResponse.message;
            }
          }
        })
        .finally(() => {
          this.otpLoader = false;
        });
    },
    handleLockoutExpired() {
      console.log('Lockout expired');
      this.isLockedOut = false;
      this.lockoutSeconds = 0;
      this.otpErrorFlag = false;
      this.errorMsg = '';
      this.digits = Array(6).fill('');
      this.focusFirstInput();
    }
  }
};
</script>

<style src="@/assets/css/authen.css"></style>
<style src="@/assets/css/newLogin.css"></style>

<style>
.otp-input-wrapper {
  gap: 25px;
  margin-bottom: 10px;
}
.auth-form .otp-input-wrapper input.otp-input {
  height: 53px ;
  border: 1px solid #bbb ;
  border-radius: 8px ;
  text-align: center ;
  font-size: 1.2rem ;
  transition: all 0.2s ease;
  box-shadow: 0;
  position: relative;
}
.auth-form .otp-input-wrapper input.otp-input::after{
  content: '-';
  position: absolute;
  right: -5px;
}
.otp-input:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);
  outline: none;
}
#label-username,
#label-password {
  font-size: 16px !important;
  color: #909090 !important;
  margin-bottom: 10px !important;
}
#username,
#password {
  font-size: 14px !important;
  padding: 12px 15px !important;
}
.rep-icon-login {
  width: 80px;
}
.rep-icon-login img {
  width: 100px;
}
.new-login-wrapper .highlight_otp {
  border: 2px solid #dc3545 !important;
}
.new-login-wrapper .valid-error {
  color: #E73737;
  background-color: #FFE9E9;
  border-radius: 6px;
  padding: 0.5rem 0.8rem;
  margin-top: 0.1rem;
}
.resend-timer-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;
}
.submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.otp-separator {
  font-size: 1.2rem;
  color: #333;
  line-height: 60px;
  margin: 0 2px;
}
.error-border {
  border-color: #dc3545 !important;
}
.login-highlight {
  cursor: pointer;
}
@media(max-width: 1399px){
  .otp-input-wrapper {
    gap: 15px;
  }
}
@media (max-width: 992px) {
    .otp-input-wrapper {
        gap: 5px;
        margin: 0 0 10px 0;
    }
}
</style>